import React from "react"
import PropTypes from "prop-types"

const ChangeStockForm = ({value, visible, onCancel, onConfirm, onChange}) => {
  return (visible &&
    <div className="shop-product-stock-form">
      <input className="form-control" type="number" value={value} onChange={onChange} />
      <button className="btn btn-green" onClick={onConfirm} />
      <button className="btn btn-red" onClick={onCancel} />
    </div>
  )
}

ChangeStockForm.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default ChangeStockForm
